import { useMutation } from '@tanstack/react-query';
import { resendTwoFactor } from '@/api/auth.api';

/**
 * Re-deliver the second-factor code for an in-flight login (FR-04).
 *
 * Takes the pre-auth token rather than an email address: the caller already
 * holds it, and keying the request on it keeps the endpoint from being usable
 * as an address-existence probe.
 *
 * Only meaningful for a factor with a delivery step - `TwoFactorPage` renders
 * no resend affordance at all for TOTP (`docs/specs/features/identity-access/02-design.md` §11 decision 4).
 */
export function useResendTwoFactor(preAuthToken: string) {
  return useMutation({ mutationFn: () => resendTwoFactor({ preAuthToken }) });
}
